export default {
    name: 'TabMenuMixin',

    data() {
        return {
            current_tab: 'main',
        };
    },

    computed: {
        current_computed_tab() {
            return this.$route.params.tab ? this.$route.params.tab : 'main';
        },
    },

    mounted() {
        this.setCurrentTabFromRoute();
    },

    methods: {
        setCurrentTabFromRoute() {
            this.current_tab = this.current_computed_tab;
        },
    },

    watch: {
        current_computed_tab(tab) {
            if (this._inactive === false) {
                this.current_tab = tab;
            }
        },

        $route() {
            this.setCurrentTabFromRoute();
        },
    },
};
